@if (data.mode=='confirm') {
<div class="top-button" (click)="onNoClick()"></div>
<div class="dialog-title">Хотите отменить подписку?</div>
<div class="dialog-text">Отменив подписку, вы больше не сможете использовать все преимущества DexBee Plus</div>
<div class="button-block">
  <button matButton (click)="onNoClick()" class="button-no">Оставить</button>
  <button matButton (click)="onYesClick()" class="button-yes">Отменить</button>
</div>
}
@if (data.mode=='completed') {
<div class="top-button" (click)="onNoClick()"></div>
<div class="ok-icon"></div>
<div class="dialog-text">Подписка отменена</div>
<div class="button-ok-block">
  <button matButton (click)="onOkClick()" class="button-ok">Ok</button>
</div>
}
